export default {
  regionLabel: {
    id: 'shopping_assistant_product_card_carousel_region_label',
    defaultMessage: 'Product recommendations',
  },
} as const
